/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1ExamExamlangidImportExamItemGridQueryResponse,
  GetApiV1ExamExamlangidImportExamItemGridPathParams,
  GetApiV1ExamExamlangidImportExamItemGridQueryParams,
  GetApiV1ExamExamlangidImportExamItemGrid400,
  GetApiV1ExamExamlangidImportExamItemGrid401,
  GetApiV1ExamExamlangidImportExamItemGrid500,
} from "../../types/examEvaluationController/GetApiV1ExamExamlangidImportExamItemGrid.ts";

function getGetApiV1ExamExamlangidImportExamItemGridUrl(
  examLangId: GetApiV1ExamExamlangidImportExamItemGridPathParams["examLangId"],
) {
  const res = {
    method: "GET",
    url: `/api/v1/exam/${examLangId}/import-exam-item-grid` as const,
  };
  return res;
}

/**
 * @description Retorna a lista paginada de questões da biblioteca disponíveis para importar em uma versão de prova (ExamLang). Filtra pelo tipo da prova: provas de avaliação docente ou de instrutor exibem apenas questões com TeacherEvaluation; provas Challenge exibem apenas tipos fechados (Escolha Simples ou Múltipla). Aceita filtros opcionais de empresa, idioma, autor, disciplina, tipo de componente e intervalo de data de criação. A empresa do usuário logado tem precedência sobre o filtro de empresa. **(Requer Authorization para autenticação)**
 * @summary Listar questões disponíveis para importação (Requer Authorization para autenticação)
 * {@link /api/v1/exam/:examLangId/import-exam-item-grid}
 */
export async function getApiV1ExamExamlangidImportExamItemGrid(
  examLangId: GetApiV1ExamExamlangidImportExamItemGridPathParams["examLangId"],
  params?: GetApiV1ExamExamlangidImportExamItemGridQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1ExamExamlangidImportExamItemGridQueryResponse,
    ResponseErrorConfig<
      | GetApiV1ExamExamlangidImportExamItemGrid400
      | GetApiV1ExamExamlangidImportExamItemGrid401
      | GetApiV1ExamExamlangidImportExamItemGrid500
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiV1ExamExamlangidImportExamItemGridUrl(
      examLangId,
    ).url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}
